<div fxLayout="row" fxLayoutAlign="center center">
  <div
    *ngIf="{
      cardPolicies: cardPolicies$ | async,
      claims: claims$ | async,
      draftCount: draftCount$ | async,
      userName: profile$ | async
    } as data"
    fxLayout="column"
    fxFlex="80"
    fxFlex.lt-md="100"
    class="mt-50"
    ngClass.lt-md="p-20 mt-10"
    fxLayoutGap="30px">
    <div fxLayout="row" fxLayoutAlign="space-between start" fxLayout.lt-md="column">
      <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start start" ngClass.lt-md="w-100 mb-20">
        <div>
          <h1 class="title-one m-0">{{ 'keywords.welcomeBack' | translate }}, {{ data.userName }}</h1>
        </div>
        <div class="text-color-gray5">{{ 'keywords.trackAndManageYourPolicies' | translate }}.</div>
      </div>
      <div
        fxLayout="row"
        fxLayoutGap="20px"
        fxLayoutGap.xs="10px"
        fxLayout.xs="column"
        fxLayout.xs="column-reverse"
        fxLayoutAlign="center center"
        ngClass.lt-md="w-100">
        <button mat-button class="transparent-background-button">
          <div routerLink="../quotes/saved-quotes">
            {{ data.draftCount }} {{ 'keywords.saved_drafts' | translate }}
            <div>
              <span class="material-symbols-outlined">auto_awesome</span>
            </div>
          </div>
        </button>

        <div fxLayout="row" fxLayoutGap="20px" fxLayoutGap.xs="10px" fxLayoutAlign="center center">
          <button mat-button class="medium-button-white" routerLink="../claims/select-claim-type">
            {{ 'keywords.submit_claim' | translate }}
          </button>
          <button mat-button class="medium-button-blue" routerLink="../quotes/select-quote-type">
            {{ 'keywords.requestQuote' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-md="column">
      <mat-card
        (click)="navigateToPolicyDetails(policy)"
        *ngFor="let policy of data.cardPolicies"
        class="blue-policy-card"
        [ngClass]="{
          'gray-policy-card': !policy.policyID,
          'grayed-out-readonly-button': policy.policyType === PolicyType.Health
        }"
        fxLayout="column"
        fxLayoutAlign="space-between stretch">
        <div class="p-20" fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start start">
          <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
            <div
              class="active-card-icon"
              [ngClass]="{ 'passive-card-icon': !policy.policyID }"
              fxLayout="column"
              fxLayoutAlign="start center">
              <span class="material-symbols-outlined">{{ getIcon(policy.policyType) }}</span>
            </div>
            <span>{{ policy.policyTitle }}</span>
          </div>
          <div class="policy-data" fxLayout="column" fxLayoutAlign="start start">
            <span ngClass.xs="w-100">{{ policy.coverageType }}</span>
            <span class="policy-id">{{ policy.policyNumber }}</span>
          </div>
          <span class="mt-20" *ngIf="policy.policyID"
            >{{ 'keywords.coverageEndOn' | translate }} {{ policy.coverageDateTo | date: 'MM/dd/yyyy' }}</span
          >
        </div>
        <div
          class="large-icon-container"
          [ngClass]="{ 'light-purple-icon': !policy.policyID }"
          fxLayout="row"
          fxLayoutAlign="end end">
          <span class="material-symbols-outlined">{{ getIcon(policy.policyType) }}</span>
        </div>
        <div *ngIf="!policy.policyID" class="p-20">
          <button mat-button (click)="getQuote(policy.policyType)" class="large-button-blue get-quote-button">
            {{ 'keywords.getQuote' | translate }}
          </button>
        </div>
      </mat-card>
    </div>

    <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-15 pl-20 pr-20">
        <h3>{{ 'keywords.policies' | translate }}</h3>

        <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="30px">
          <app-dropdown
            fxFlex="0 0 150px"
            [(ngModel)]="policyStatusFilter"
            [showLabel]="false"
            [itemList]="policyStatusDropDown"
            (selectEvent)="filterStatus($event.value)" />

          <button
            mat-button
            routerLink="../policy"
            routerLinkActive="router-link-active"
            class="transparent-background-button">
            {{ 'keywords.viewPolicyPage' | translate }}
          </button>
        </div>
      </div>
      <!-- POLICIES TABLE -->
      <div class="table-section">
        <table mat-table matSort matSort [dataSource]="policySource">
          <ng-container matColumnDef="policyTitle">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.policy' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default w-100">
              <div class="mat-cell-header">{{ 'keywords.policy' | translate }}</div>
              <div class="mat-cell-value">
                <div class="policy-name">
                  <div class="marine-blue-icon">
                    <span class="material-symbols-outlined">{{ getIcon(item.policyType) }} </span>
                  </div>
                  <div class="policy-name-text-content">
                    <span class="text-color-black mb-5">{{ item.policyTitle }}</span>
                    <span>{{ item.name }}</span>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="policyNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.policyNumber' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.policyNumber' | translate }}</div>
              <div class="mat-cell-value">
                {{ item.policyNumber }}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="coverageType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.coverageType' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.coverageType' | translate }}</div>
              <div class="mat-cell-value">
                {{ item.coverageType }}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="coverageDate">
            <th mat-header-cell *matHeaderCellDef class="table-title">
              {{ 'keywords.coverageDate' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.coverageDate' | translate }}</div>
              <div class="mat-cell-value">
                {{ (item.coverageDateFrom | date: 'shortDate') + ' - ' + (item.coverageDateTo | date: 'shortDate') }}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="policyStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.policyStatus' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.policyStatus' | translate }}</div>
              <div class="mat-cell-value" [innerHTML]="getPolicyActivityStatusHTML(item.policyStatus)"></div>
            </td>
          </ng-container>

          <ng-container matColumnDef="balance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.common.balance' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.common.balance' | translate }}</div>
              <div class="mat-cell-value">{{ item.balance | currency: 'USD' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="nextPayment">
            <th mat-header-cell *matHeaderCellDef class="table-title">
              {{ 'keywords.common.next_payment' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.common.next_payment' | translate }}</div>
              <div class="mat-cell-value">{{ item.nextPayment | date: 'MM/dd/yyyy' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.common.amount' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.common.amount' | translate }}</div>
              <div class="mat-cell-value">{{ item.amount | currency: 'USD' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="table-title"></th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-value">
                <button mat-icon-button class="text-color-marine-blue" [matMenuTriggerFor]="actionOptions">
                  <span class="material-symbols-outlined">vertical_align_bottom</span>
                </button>
              </div>
              <mat-menu #actionOptions="matMenu" xPosition="before">
                <div fxLayout="column" fxLayoutAlign="start start">
                  <button mat-button class="mat-menu-button" (click)="menuItemClicked(item, 'Schedule')">
                    Schedule
                  </button>
                  <button
                    *ngIf="item.policyType === PolicyType.Motor"
                    mat-button
                    class="mat-menu-button"
                    (click)="menuItemClicked(item, documentNames.certificate)">
                    Certificate
                  </button>
                  <button mat-button class="mat-menu-button" (click)="menuItemClicked(item, documentNames.endorsment)">
                    Endorsement
                  </button>
                  <button mat-button class="mat-menu-button" (click)="menuItemClicked(item, documentNames.policy)">
                    Policy
                  </button>
                </div>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsPolicies"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsPolicies"></tr>
        </table>
      </div>
      <!-- <div class="paginator-section">
        <div class="flex-cell">
          <mat-paginator #policiesPaginator showFirstLastButtons="true" [length]="pagingPolicies.totalCount"
            [pageIndex]="pagingPolicies.pageNumber-1" [pageSize]="pagingPolicies.pageSize"
            [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </div>
      </div> -->
    </div>

    <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-15 pl-20 pr-20">
        <h3>{{ 'keywords.openClaims' | translate }}</h3>
        <button mat-button routerLink="../claims" class="transparent-background-button">
          {{ 'keywords.viewClaims' | translate }}
        </button>
      </div>
      <!-- CLAIMS TABLE -->
      <!-- class="border" -->
      <div class="table-section">
        <!-- <div [ngClass]="{'invisible': !showLoadingIndicator}" class="position-absolute w-100 h-100">
          <mat-progress-spinner class="loading-indicator" mode="indeterminate" diameter="64">
          </mat-progress-spinner>
        </div> -->

        <!-- [ngClass]="{ 'blurry-table': showLoadingIndicator }" -->
        <!-- class="table-border" -->
        <table mat-table matSort [dataSource]="claimSource">
          <ng-container matColumnDef="claimType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.claim_type' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default w-30">
              <div class="mat-cell-header">{{ 'keywords.claim_type' | translate }}</div>
              <div class="mat-cell-value">
                <div class="policy-name">
                  <div class="marine-blue-icon">
                    <span class="material-symbols-outlined">{{ getIcon(item.policyType) }} </span>
                  </div>
                  <div class="policy-name-text-content">
                    <span class="text-color-black mb-5">{{ item.policyTitle }}</span>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="risk">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.risk' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.risk' | translate }}</div>
              <div class="mat-cell-value">
                {{ item.risk }}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="claimNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.claim_no' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.claim_no' | translate }}</div>
              <div class="mat-cell-value">
                {{ item.claimNumber }}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.status' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.status' | translate }}</div>
              <div class="mat-cell-value" [innerHTML]="getClaimActivityStatusHTML(item.status)"></div>
            </td>
          </ng-container>

          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.common.amount' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.common.amount' | translate }}</div>
              <div class="mat-cell-value">{{ item.amount | currency: 'USD' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="accidentDate">
            <th mat-header-cell *matHeaderCellDef class="table-title" start="desc">
              {{ 'keywords.date_of_incident' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.date_of_incident' | translate }}</div>
              <div class="mat-cell-value">
                {{ convertDateTimeFormat(item.accidentDate) }}
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsClaims"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsClaims"></tr>
        </table>
      </div>
      <!-- <div class="paginator-section">
        <div class="flex-cell">
          <mat-paginator #claimsPaginator showFirstLastButtons="true" [length]="pagingClaims.totalCount"
            [pageIndex]="pagingClaims.pageNumber-1" [pageSize]="pagingClaims.pageSize"
            [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </div>
      </div> -->
    </div>

    <!-- PAYMENTS TABLE -->
    <!-- <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-15 pl-20 pr-20">
        <h3>{{ 'keywords.upcomingPayments' | translate }}</h3>
        <button mat-button routerLink="../payments" class="transparent-background-button">
          {{ 'keywords.goToPayments' | translate }}
        </button>
      </div>
      <div class="table-section mb-50">
        <table mat-table matSort [dataSource]="paymentSource">
          <ng-container matColumnDef="policyTitle">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.policy_name' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default w-100">
              <div class="mat-cell-header">{{ 'keywords.policy_name' | translate }}</div>
              <div class="mat-cell-value">
                <div class="policy-name">
                  <div class="marine-blue-icon">
                    <span class="material-symbols-outlined">{{ getIcon(item.policyType) }} </span>
                  </div>
                  <div class="policy-name-text-content">
                    <span class="text-color-black mb-5">{{ item.policyTitle }}</span>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="policyID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.policy_no' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.policy_no' | translate }}</div>
              <div class="mat-cell-value">
                {{ item.policyID }}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="nextPayment">
            <th mat-header-cell *matHeaderCellDef class="table-title">{{ 'keywords.next_payment' | translate }}</th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.next_payment' | translate }}</div>
              <div class="mat-cell-value">
                {{ item.nextPayment }}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header start="desc" disableClear="true" class="table-title">
              {{ 'keywords.common.amount' | translate }}
            </th>
            <td mat-cell *matCellDef="let item; index as index" class="default">
              <div class="mat-cell-header">{{ 'keywords.common.amount' | translate }}</div>
              <div class="mat-cell-value">
                <span class="fw-500">{{ item.amount | currency: 'USD' }}</span>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsPayments"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsPayments"></tr>
        </table>
      </div>
    </div> -->
  </div>
</div>
